import React from 'react'
import { initializeApollo } from 'gql/client'
import { PAGINA } from 'utils/queries'
import RegistrazioneTemplate from '@components/templates/RegistrazioneTemplate/RegistrazioneTemplate'
import { NextWrapper } from 'data-fetching-wrapper'

const NewsletterPage = ({ pagina }) => <RegistrazioneTemplate pagina={pagina} preferenzeOpen />

export const getStaticProps = NextWrapper.getStaticProps(async () => {
  const client = initializeApollo()

  const {
    data: { pagina },
  } = await client.query({
    query: PAGINA,
    variables: { chiave: 'registrazione-e-preferenze' },
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  return {
    props: { pagina },
    revalidate: 60 * 2,
  }
}, '/registrazione-e-preferenze')

export default NewsletterPage
